import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import { SectionWithTitle } from 'components/SectionWithTitle/SectionWithTitle'
import { breakpointUpTo } from 'utils/breakpoints'
import { ILocation } from 'types/home-page'

const StyledUl = styled.ul`
  display: flex;
  flex-wrap: wrap;
  max-width: 954px;
  margin: -${({ theme }) => theme.space[3]} auto 0;

  li {
    width: calc(100% / 6);
    margin-top: ${({ theme }) => theme.space[3]};

    ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
      width: 25%;
    }

    ${({ theme }) => breakpointUpTo(theme.breakpoints.sm)} {
      &:nth-child(even) {
        margin-left: ${({ theme }) => theme.space[4]};
      }

      width: calc(50% - 12px);
      text-align: left;
    }
  }

  a {
    display: block;
    width: 100%;

    :hover,
    :focus {
      text-decoration: underline;
    }
  }
`

const StyledLink = styled(Link)`
  ${({ theme }) => theme.typography.XLBody1}
  color: ${({ theme }) => theme.colors.primary};

  ${({ theme }) => breakpointUpTo(theme.breakpoints.xl)} {
    ${({ theme }) => theme.typography.LrgBody1}
  }

  ${({ theme }) => breakpointUpTo(theme.breakpoints.lg)} {
    ${({ theme }) => theme.typography.MedBody1}
  }

  ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
    ${({ theme }) => theme.typography.SmBody1}
  }
`

export type DeliveryLocationsProps = {
  title: string
  locations: ILocation[] | string[]
  pathnamePrefix?: string
}

export const DeliveryLocations = ({
  title,
  locations,
  pathnamePrefix,
}: DeliveryLocationsProps) => {
  return (
    <SectionWithTitle title={title}>
      <StyledUl>
        {locations.map((location) => {
          return typeof location === 'string' ? (
            <li key={location}>{location}</li>
          ) : (
            <li key={location.id}>
              <StyledLink
                to={`${
                  pathnamePrefix
                    ? `/${pathnamePrefix}/${location.path}`
                    : `/${location.path}`
                }`}
              >
                {location.name}
              </StyledLink>
            </li>
          )
        })}
      </StyledUl>
    </SectionWithTitle>
  )
}
